// NB: Synchronize with server and client.
export const CategoryType = {
    Game: "GAME",
    Discovery: "DISCOVERY",
    WeeklyRecommendedDiscovery: "DISCOVERY_WEEKLY_RECOMMENDED",
    NewReleaseDiscovery: "DISCOVERY_NEW_RELEASE",
    App: "APP",
    Io: "IO",
    GameIo: "GAME_IO"
};